'use strict';

define('app/loginStartup', ['jquery', 'knockout', 'app/setup/components', 'app/setup/componentLoaders', 'components/selectBox/selectBox'], function (jquery, ko) {

	ko.applyBindings({}, document.body);
});
